var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-card',{attrs:{"md-with-hover":""}},[_c('md-card-header',[_c('div',{staticClass:"md-title"},[_vm._v("COMUNICAZIONE SICURA")]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v("Non sei autorizzato ad accedere a questa pagina.")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f89a9a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Unauthorized.vue
// module id = null
// module chunks = 